import { actionTree } from 'typed-vuex';
import initialState from '@/store/modules/link/state';
import mutations from '@/store/modules/link/mutations';
import getters from '@/store/modules/link/getters';
import factory from '@/repositories/fo-manual-API/RepositoryFactory';
import { Link, LinkGetParams } from '@/repositories/fo-manual-API/LinksRepository/types';

const linksRepo = factory.get('links');

const actions = actionTree(
  { state: initialState, getters, mutations },
  {
    getLinks({ commit }, params: LinkGetParams | null = null) {
      linksRepo.getAll(params).then((res) => {
        commit('SET_LINKS', res.data);
      });
    },
    createLink({ commit }, payload: Link) {
      linksRepo.create(payload).then((res) => {
        commit('SET_LINK', res.data);
      });
    },
    async updateLink({ commit }, payload: Partial<Link>) {
      const { id, ...data } = payload;
      if (id) {
        const res = await linksRepo.update(id, data);
        commit('UPDATE_LINK', res.data);
      }
    },
    async deleteLink({ commit }, payload: Link) {
      const { id } = payload;
      await linksRepo.delete(id);
      commit('DELETE_LINK', payload);
    },
  },
);

export default actions;
